<template>
  <div>
    <TopHeader code="know" />

    <section class="uc-encyclopediasBanner">
      <div class="container">
        <div class="info">
          <!-- <h2>Tai百科</h2>
          <p>让知识自己联动起来</p> -->
          <div class="con uc-pt150">
            <div class="item">
              <b>{{ list.total_count || 0 }} </b>词条数
            </div>
            <div class="item uc-pt10">
              <b
                >{{
                  ((list.items || [])[0] || {}).total_reference_count || 0
                }} </b
              >次知识关联
            </div>
          </div>
          <!-- <div class="operate">
            <button class="uc-btn blue" hover-class="none">创建词条</button>
          </div> -->
        </div>
        <img src="../../assets/images/img221.gif" class="icon" />
      </div>
    </section>

    <section class="container-fluid uc-bg uc-pt100 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-18">
            <section class="g-filterSearch uc-ml10 uc-pr10">
              <div
                :class="tab == 'tab1' ? 'item on' : 'item'"
                @click="
                  tab = 'tab1';
                  loadData();
                "
              >
                最新
              </div>
              <div
                :class="tab == 'tab2' ? 'item on' : 'item'"
                @click="
                  tab = 'tab2';
                  loadData();
                "
              >
                最热
              </div>
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想查询的百科"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="loadData"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />
              </div>
            </section>
            <div v-show="tab == 'tab1'">
              <section class="container uc-encyclopediasList">
                <div class="content-empty" v-if="list.total_count == 0">
                  <div class="emptyimg-box"></div>
                  <p>暂无相关内容</p>
                </div>
                <div class="row">
                  <div
                    v-for="(item, index) in list.items"
                    :key="index"
                    class="col-8 box"
                  >
                    <router-link
                      :to="{
                        name: 'KnowPointDetails',
                        params: { id: item.id },
                      }"
                      class="item"
                    >
                      <h3>{{ item.title }}</h3>
                      <div class="txt">
                        {{ item.definition }}
                      </div>
                      <div class="btm">
                        <div class="l">编辑者：{{ item.create_user_name }}</div>
                        <div class="r">
                          <img
                            src="../../assets/images/icon231.png"
                            class="uc-icon16"
                          />{{ item.reference_count }}次
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </section>
            </div>
            <div v-show="tab == 'tab2'">
              <section class="container uc-encyclopediasList">
                <div class="content-empty" v-if="list.total_count == 0">
                  <div class="emptyimg-box"></div>
                  <p>暂无相关内容</p>
                </div>
                <div class="row">
                  <div
                    v-for="(item, index) in list.items"
                    :key="index"
                    class="col-8 box"
                  >
                    <router-link
                      :to="{
                        name: 'KnowPointDetails',
                        params: { id: item.id },
                      }"
                      class="item"
                    >
                      <h3>{{ item.title }}</h3>
                      <div class="txt">
                        {{ item.definition }}
                      </div>
                      <div class="btm">
                        <div class="l">编辑者：{{ item.create_user_name }}</div>
                        <div class="r">
                          <img
                            src="../../assets/images/icon231.png"
                            class="uc-icon16"
                          />{{ item.reference_count }}次
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </section>
            </div>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>

          <div class="col-24 col-sm-6">
            <section class="g-sideRankingList">
              <div class="title">
                <img
                  src="../../assets/images/icon221.png"
                  class="uc-icon24"
                />关联排行
              </div>
              <div class="content-empty" v-if="rankList.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="list">
                <div
                  v-for="(item, index) in rankList.items"
                  :key="index"
                  class="item"
                >
                  <i class="num">{{ index + 1 }}</i>
                  <router-link
                    class="name"
                    :to="{
                      name: 'KnowPointDetails',
                      params: { id: item.id },
                    }"
                    >{{ item.title }}</router-link
                  >
                  <i class="number">{{ item.reference_count }}次</i>
                </div>
              </div>
            </section>
            <!-- <section class="g-sideSearchKeyWord">
              <div class="title">
                <img
                  src="../../assets/images/icon222.png"
                  
                  class="uc-icon24"
                />热门搜索
              </div>
              <div class="list">
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
                <span class="uc-tag blue-light">移动互联网</span>
                <span class="uc-tag blue-light">一起爬山啊</span>
                <span class="uc-tag blue-light">百科让知识联动起来</span>
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
                <span class="uc-tag blue-light">移动互联网</span>
                <span class="uc-tag blue-light">一起爬山啊</span>
                <span class="uc-tag blue-light">百科让知识联动起来</span>
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
                <span class="uc-tag blue-light">移动互联网</span>
                <span class="uc-tag blue-light">一起爬山啊</span>
                <span class="uc-tag blue-light">百科让知识联动起来</span>
                <span class="uc-tag blue-light">新品太</span>
                <span class="uc-tag blue-light">发动机</span>
              </div>
            </section> -->
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'KnowPoint',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      tab: 'tab1',
      query: {
        pageIndex: 1,
        pageSize: 9,
        keyword: undefined,
      },
      queryRank: {
        pageIndex: 1,
        pageSize: 15,
        keyword: undefined,
      },
      list: [],
      rankList: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getKnowPoints();
      this.getKnowPointsRank();
    },
    loadData() {
      this.tab === 'tab1' ? this.getKnowPoints() : this.getHotKnowPoints();
    },
    async getKnowPoints() {
      const response = await this.$api.knowpoint.getKnowPoints(this.query);
      this.list = response.data.data;
    },
    async getHotKnowPoints() {
      const response = await this.$api.knowpoint.getHotKnowPoints(this.query);
      this.list = response.data.data;
    },
    async getKnowPointsRank() {
      const response = await this.$api.knowpoint.getHotKnowPoints(
        this.queryRank
      );
      this.rankList = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
